import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import ConfirmOrderPage from './ConfirmOrderPage';
import './ConfirmOrderPage.less';

export const prefix = 'bm-p-confirm-order';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: ConfirmOrderPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
